/** Absolute paths for the Alerts workspace. The mode lives in the URL. */
export const ALERTS_URL = {
  ROOT: "/alerts",
  /** Current operator work — the index route under ROOT. */
  QUEUE: "/alerts",
  /** Bounded historical search. */
  HISTORY: "/alerts/history",
  /** Workload and outcomes for site leads and supervisors. */
  ANALYTICS: "/alerts/analytics",
  /** Staff-only ingest observability. */
  MONITORING: "/alerts/monitoring",
} as const;
